import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import AdminLayout from '@/components/common/AdminLayout'
import AdminDashboardScreen from '@/screens/admin/AdminDashboardScreen'
import RestaurantManagementScreen from '@/screens/admin/RestaurantManagementScreen'
import SubscriptionManagementScreen from '@/screens/admin/SubscriptionManagementScreen'
import UserManagementScreen from '@/screens/admin/UserManagementScreen'
import ApiKeyManagementScreen from '@/screens/admin/ApiKeyManagementScreen'
import GlobalSettingsScreen from '@/screens/admin/GlobalSettingsScreen'
import ValidationLogsScreen from '@/screens/admin/ValidationLogsScreen'
import BannerManagementScreen from '@/screens/admin/BannerManagementScreen'
import DbManagementScreen from '@/screens/admin/DbManagementScreen'
import DeviceManagementScreen from '@/screens/admin/DeviceManagementScreen'
import OrdoreMiniScreen from '@/screens/admin/OrdoreMiniScreen'
import FeatureListScreen from '@/screens/admin/FeatureListScreen'
export default function AdminNavigator() {
  return (
    <AdminLayout>
      <Routes>
        <Route path="/" element={<Navigate to="/admin/dashboard" replace />} />
        <Route path="/admin/dashboard" element={<AdminDashboardScreen />} />
        <Route path="/admin/restaurants" element={<RestaurantManagementScreen />} />
        <Route path="/admin/feature-list" element={<FeatureListScreen />} />
        <Route path="/admin/subscriptions" element={<SubscriptionManagementScreen />} />
        <Route path="/admin/users" element={<UserManagementScreen />} />
        <Route path="/admin/api-keys" element={<ApiKeyManagementScreen />} />
        <Route path="/admin/db-management" element={<DbManagementScreen />} />
        <Route path="/admin/portal-settings" element={<GlobalSettingsScreen />} />
        <Route path="/admin/validation-logs" element={<ValidationLogsScreen />} />
        <Route path="/admin/banner" element={<BannerManagementScreen />} />
        <Route path="/admin/devices" element={<DeviceManagementScreen />} />
        <Route path="/admin/ordore-mini" element={<OrdoreMiniScreen />} />
        <Route path="*" element={<Navigate to="/admin/dashboard" replace />} />
      </Routes>
    </AdminLayout>
  )
}